module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/external/react-native-view/components/TextInput/asset/close.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/external/react-native-view/components/TextInput/asset/close.png
// module id = 802
// module chunks = 418